import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// MATERIAL
import { MatCardModule } from '@angular/material/card';

// EUI
import { EuiIconModule } from '../atoms';
import { EuiButtonModule } from '../eui-button/eui-button.component';
import { EuiDropdownModule } from '../eui-dropdown/eui-dropdown.component';
import { EuiTooltipDirectiveModule } from '../../directives';
import { UxOverlayComponentModule } from '@eui/components';

// CARD COMPONENTS
import { EuiCardComponent } from './eui-card.component';
import { EuiCardHeaderComponent } from './components/eui-card-header/eui-card-header.component';
import { EuiCardHeaderTitleComponent } from './components/eui-card-header/eui-card-header-title.component';
import { EuiCardHeaderSubtitleComponent } from './components/eui-card-header/eui-card-header-subtitle.component';
import { EuiCardHeaderLeftContentComponent } from './components/eui-card-header/eui-card-header-left-content.component';
import { EuiCardHeaderRightContentComponent } from './components/eui-card-header/eui-card-header-right-content.component';

import { EuiCardHeaderBodyComponent } from './components/eui-card-header-body/eui-card-header-body.component';
import { EuiCardMediaComponent } from './components/eui-card-media/eui-card-media.component';
import { EuiCardContentComponent } from './components/eui-card-content/eui-card-content.component';
import { EuiCardFooterComponent } from './components/eui-card-footer/eui-card-footer.component';
import { EuiCardFooterMenuContentComponent } from './components/eui-card-footer/eui-card-footer-menu-content.component';
import { EuiCardFooterActionButtonsComponent } from './components/eui-card-footer/eui-card-footer-action-buttons.component';
import { EuiCardFooterActionIconsComponent } from './components/eui-card-footer/eui-card-footer-action-icons.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatCardModule,
        EuiIconModule,
        EuiButtonModule,
        EuiDropdownModule,
        EuiTooltipDirectiveModule,
        UxOverlayComponentModule,
    ],
    declarations: [
        EuiCardComponent,
        EuiCardHeaderComponent,
        EuiCardHeaderTitleComponent,
        EuiCardHeaderSubtitleComponent,
        EuiCardHeaderLeftContentComponent,
        EuiCardHeaderRightContentComponent,
        EuiCardHeaderBodyComponent,
        EuiCardMediaComponent,
        EuiCardContentComponent,
        EuiCardFooterComponent,
        EuiCardFooterMenuContentComponent,
        EuiCardFooterActionButtonsComponent,
        EuiCardFooterActionIconsComponent,
    ],
    exports: [
        EuiCardComponent,
        EuiCardHeaderComponent,
        EuiCardHeaderTitleComponent,
        EuiCardHeaderSubtitleComponent,
        EuiCardHeaderBodyComponent,
        EuiCardHeaderLeftContentComponent,
        EuiCardHeaderRightContentComponent,
        EuiCardMediaComponent,
        EuiCardContentComponent,
        EuiCardFooterComponent,
        EuiCardFooterMenuContentComponent,
        EuiCardFooterActionButtonsComponent,
        EuiCardFooterActionIconsComponent,
    ],
})
export class EuiCardModule { }
